import { createApi } from "@reduxjs/toolkit/query/react";

import { TGetCategoriesResponse } from "./api.types";
import { baseQueryWithReAuth } from "./apiConfig";

export const categoriesApi = createApi({
	reducerPath: "categoriesApi",
	baseQuery: baseQueryWithReAuth,
	endpoints: (builder) => ({
		getCategories: builder.query<TGetCategoriesResponse, boolean | void>({
			query: (allParents = false) => {
				return {
					url: `products/category/`,
					method: "GET",
					params: {
						only_parents: allParents,
					}
				};
			},
		}),
	}),
});

export const { useGetCategoriesQuery } = categoriesApi;
